
// // import React, { useState } from 'react';
// // import styled from 'styled-components';
// import React, { useState, useEffect } from 'react';
// import ImageSlider from '../Components/ImageSlider';
// import styled from 'styled-components';
// import { ref, set, push, onValue, remove } from 'firebase/database';
// import { ref as storageRef, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // import { storage } from '../firebaseConfig';
// import { db, storage } from '../firebaseConfig'; // Correct import
// const MainContainer = styled.div`
//   margin: 0;
//   padding: 0;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-bottom: 20px;
// `;

// const ImagePicker = styled.div`
//   margin: 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   /* background-color: #e5ff00; */
// `;

// const ImagePreviewContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   margin-top: 20px;
//   /* background-color: red; */
// `;

// const ImagePreviewImg = styled.img`
//   width: 150px;
//   height: auto;
//   border-radius: 10px;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
//   margin-bottom: 10px;
// `;

// const ImageInput = styled.input`
//   margin-top: 20px;
//   padding: 10px;
//   font-size: 16px;
//   cursor: pointer;
//   /* background-color: blueviolet; */
// `;

// const TitleInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 18px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const DescriptionInput = styled.textarea`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   height: 100px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const UrlInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const SubmitButton = styled.button`
//   margin-top: 20px;
//   padding: 10px 20px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   color: white;
//   background-color: green;

//   &:hover {
//     background-color: darkgreen;
//   }
// `;

// const Card = styled.div`
//   border: 1px solid #ddd;
//   border-radius: 10px;
//   overflow: hidden;
//   width: 300px;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 15px;
//   background-color: #fff;
//   position: relative;
// `;

// const CardImage = styled.img`
//   width: 270px;
//   height: 270px;
//   object-fit: cover;
//   border-radius: 10px;
// `;

// const CardTitle = styled.h3`
//   margin: 10px 0;
//   font-size: 20px;
//   color: darkblue;
// `;

// const CardDescription = styled.p`
//   font-size: 16px;
//   color: #333;
//   text-align: center;
//   max-height: ${(props) => (props.expanded ? 'none' : '60px')};
//   overflow: hidden;
// `;

// const ToggleButton = styled.button`
//   background-color: transparent;
//   color: blue;
//   border: none;
//   cursor: pointer;
//   margin-top: 10px;
// `;

// const ButtonContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-top: 10px;
//   gap: 10px;
// `;

// const BuyButton = styled.a`
//   background-color: blue;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   padding: 8px 16px;
//   cursor: pointer;
//   text-decoration: none;

//   &:hover {
//     background-color: darkblue;
//   }
// `;

// const DeleteButton = styled.button`
//   background-color: red;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   padding: 8px 16px;
//   cursor: pointer;

//   &:hover {
//     background-color: darkred;
//   }
// `;
// const MainSecondContainer = styled.div`
//     margin: 0%;
//     padding: 0%;
//     box-sizing: border-box;
//     margin-left: 44px;
//     margin-right: 44px;
//     /* background-color: red; */
// `


// const Home = () => {
//   const [image, setImage] = useState(null);
//   const [imagePreviewUrl, setImagePreviewUrl] = useState(null); // Preview URL state
//   const [title, setTitle] = useState('');
//   const [description, setDescription] = useState('');
//   const [url, setUrl] = useState('');
//   const [cards, setCards] = useState([]);
//   const [expandedCard, setExpandedCard] = useState(null);

//   const userRole = 'admin';

//   useEffect(() => {
//     const cardsRef = ref(db, 'cards');
//     onValue(cardsRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//             const loadedCards = Object.entries(data)
//                 .map(([key, value]) => ({
//                     id: key,
//                     ...value
//                 }))
//                 .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by createdAt
//             setCards(loadedCards);
//         }
//     });
// }, []);

 

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const storageReference = storageRef(storage, `images/${file.name}`);
//       const uploadTask = uploadBytesResumable(storageReference, file);

//       uploadTask.on(
//         "state_changed",
//         (snapshot) => {
//           // Optional: Track progress
//         },
//         (error) => {
//           console.error("Upload failed: ", error);
//         },
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//             setImage(downloadURL); // Save the image URL for submission
//             setImagePreviewUrl(URL.createObjectURL(file)); // Create a local URL for preview
//           });
//         }
//       );
//     }
//   };

//   const handleSubmit = () => {
//     if (image && title && description && url) {
//       const newCardRef = push(ref(db, 'cards'));
//       const cardData = {
//         url: image,
//         title,
//         description,
//         buyUrl: url,
//         createdAt: new Date().toISOString() // Save the current timestamp
//       };

//       set(newCardRef, cardData);

//       // Reset fields
//       setImage(null);
//       setImagePreviewUrl(null); // Clear the preview URL
//       setTitle('');
//       setDescription('');
//       setUrl('');
//     } else {
//       alert('Please provide image, title, description, and product URL before submitting.');
//     }
//   };

//   const handleDelete = (cardId) => {
//     const cardRef = ref(db, `cards/${cardId}`);
//     remove(cardRef)
//       .then(() => {
//         setCards(cards.filter(card => card.id !== cardId));
//       })
//       .catch(error => {
//         console.error("Error deleting card: ", error);
//       });
//   };

//   const toggleDescription = (index) => {
//     setExpandedCard(expandedCard === index ? null : index);
//   };

//   return (
//     <MainContainer>
//       <ImageSlider />
//       <MainSecondContainer>
//         {userRole === 'admin' ? (
//           <ImagePicker>
//             <h1>Select the Image</h1>
//             <ImageInput
//               type="file"
//               accept="image/*"
//               onChange={handleImageChange}
//             />
//             {imagePreviewUrl && <ImagePreviewImg src={imagePreviewUrl} alt="Selected" />}
//             <TitleInput
//               type="text"
//               placeholder="Enter Image Title"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//             />
//             <DescriptionInput
//               placeholder="Enter Image Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//             />
//             <UrlInput
//               type="text"
//               placeholder="Enter Product URL"
//               value={url}
//               onChange={(e) => setUrl(e.target.value)}
//             />
//             <SubmitButton onClick={handleSubmit}>
//               Submit
//             </SubmitButton>
//           </ImagePicker>
//         ) : (
//           <p>Access to image picker is restricted to admins only.</p>
//         )}

//         <ImagePreviewContainer>
//           {cards.map((item, index) => (
//             <Card key={item.id}>
//               <CardImage src={item.url} alt={`Image ${index + 1}`} />
//               <CardTitle>{item.title}</CardTitle>
//               <CardDescription expanded={expandedCard === index}>
//                 {item.description}
//               </CardDescription>
//               <ToggleButton onClick={() => toggleDescription(index)}>
//                 {expandedCard === index ? 'Read Less' : 'Read More'}
//               </ToggleButton>
//               <ButtonContainer>
//                 {userRole === 'client' && item.buyUrl && (
//                   <BuyButton href={item.buyUrl} target="_blank">Buy Now</BuyButton>
//                 )}
//                 {userRole === 'admin' && (
//                   <DeleteButton onClick={() => handleDelete(item.id)}>Delete</DeleteButton>
//                 )}
//                 {userRole === 'admin' && item.buyUrl && (
//                   <BuyButton href={item.buyUrl} target="_blank">Buy Now</BuyButton>
//                 )}
//               </ButtonContainer>
//             </Card>
//           ))}
//         </ImagePreviewContainer>
//       </MainSecondContainer>
//     </MainContainer>
//   );
// };

// export default Home;







// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { ref, set, push, onValue, remove } from 'firebase/database';
// import { ref as storageRef, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import { db, storage } from '../firebaseConfig'; // Firebase configuration
// import ImageSlider from '../Components/ImageSlider';

// // Styled components
// const MainContainer = styled.div`
//   margin: 0;
//   padding: 0;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-bottom: 20px;
// `;

// const EmailInput = styled.input`
//   margin-top: 20px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const EnterButton = styled.button`
//   margin-top: 10px;
//   padding: 10px 20px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   color: white;
//   background-color: blue;

//   &:hover {
//     background-color: darkblue;
//   }
// `;

// const ImagePicker = styled.div`
//   margin: 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const ImagePreviewContainer = styled.div`
// width:100%;
// height:auto;
//   display: flex;
  
//   flex-wrap: wrap;
//   gap: 20px;
//   // background-color:red;
//   justify-content: center;
//   align-items: center;
//   /* background-color: red; */
//   margin-top: 20px;
// `;

// const ImagePreviewImg = styled.img`
//   width: 150px;
//   height: auto;
//   border-radius: 10px;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
//   margin-bottom: 10px;
// `;

// const ImageInput = styled.input`
//   margin-top: 20px;
//   padding: 10px;
//   font-size: 16px;
//   cursor: pointer;
// `;

// const TitleInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 18px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const DescriptionInput = styled.textarea`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   height: 100px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const UrlInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const SubmitButton = styled.button`
//   margin-top: 20px;
//   padding: 10px 20px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   color: white;
//   background-color: green;

//   &:hover {
//     background-color: darkgreen;
//   }
// `;

// const Card = styled.div`
//   border: none;
//   border-radius: 15px;
//   overflow: hidden;
//   justify-content: center;
//   width: 100%;
//   max-width: 350px; /* Card ki ek upper limit define kare */
//   box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow effect */
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 20px;
//   background-color: #fff;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   /* Hover effect */
//   &:hover {
//     transform: scale(1.05); /* Thoda zoom on hover */
//     box-shadow: 0px 12px 20px rgba(0, 0, 0, 0.2);
//   }

//   /* For images inside the card */
//   img {
//     width: 100%;
//     height: auto;
//     border-radius: 10px;
//     object-fit: cover; /* Image ko properly adjust kare */
//     margin-bottom: 15px; /* Spacing between image and other content */
//   }

//   /* Card content alignment */
//   h3 {
//     font-size: 1.5rem;
//     color: #333;
//     margin: 10px 0;
//   }

//   p {
//     font-size: 1rem;
//     color: #666;
//     text-align: center;
//     line-height: 1.5;
//   }

//   /* Responsive Design */
//   @media (max-width: 768px) {
//     padding: 15px;
//     max-width: 90%; /* Mobile ke liye width adjust kare */
//   }

//   @media (max-width: 480px) {
//     padding: 10px;
//     max-width: 100%;
//   }
// `;


// const CardImage = styled.img`
//   width: 270px;
//   height: 270px;
//   object-fit: cover;
//   border-radius: 10px;
// `;

// const CardTitle = styled.h3`
//   margin: 10px 0;
//   font-size: 20px;
//   color: darkblue;
// `;

// const CardDescription = styled.p`
//   font-size: 16px;
//   color: #333;
//   text-align: center;
// `;

// const CardButton = styled.button`
//   margin-top: 10px;
//   padding: 10px 20px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   background-color: #28a745;
//   color: white;

//   &:hover {
//     background-color: #218838;
//   }
// `;
// const ResponsiveTitle = styled.h1`
//   font-size: 2.5rem;
//   text-align: center;
//   margin: 20px 0;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 1.5rem;
//   }
// `;

// const DeleteButton = styled.button`
//   margin-top: 10px;
//   padding: 10px 20px;
//   font-size: 16px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   background-color: #dc3545;
//   color: white;

//   &:hover {
//     background-color: #c82333;
//   }
// `;

// const Home = () => {
//   const [email, setEmail] = useState(""); // User email
//   const [isAdmin, setIsAdmin] = useState(false); // Admin status
//   const [image, setImage] = useState(null);
//   const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
//   const [title, setTitle] = useState('');
//   const [description, setDescription] = useState('');
//   const [url, setUrl] = useState('');
//   const [cards, setCards] = useState([]);

//   useEffect(() => {
//     const cardsRef = ref(db, 'cards');
//     onValue(cardsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const loadedCards = Object.entries(data).map(([key, value]) => ({
//           id: key,
//           ...value,
//         }));
//         setCards(loadedCards.reverse());
//       }
//     });
//   }, []);

//   const handleEmailChange = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleEnterClick = () => {
//     if (email === "umerbazaribrahim@gmail.com") {
//       setIsAdmin(true);
//       alert("Welcome Admin!");
//     } else {
//       setIsAdmin(false);
//       alert("You are viewing the Client Panel!");
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const storageReference = storageRef(storage, `images/${file.name}`);
//       const uploadTask = uploadBytesResumable(storageReference, file);

//       uploadTask.on(
//         "state_changed",
//         null,
//         (error) => console.error("Upload failed: ", error),
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//             setImage(downloadURL);
//             setImagePreviewUrl(URL.createObjectURL(file));
//           });
//         }
//       );
//     }
//   };

//   const handleSubmit = () => {
//     if (image && title && description && url) {
//       const newCardRef = push(ref(db, 'cards'));
//       const cardData = {
//         url: image,
//         title,
//         description,
//         buyUrl: url,
//         createdAt: new Date().toISOString(),
//       };

//       set(newCardRef, cardData);
//       setImage(null);
//       setImagePreviewUrl(null);
//       setTitle('');
//       setDescription('');
//       setUrl('');
//     } else {
//       alert('Please fill in all fields before submitting.');
//     }
//   };

//   const handleDelete = (id) => {
//     const cardRef = ref(db, 'cards/' + id);
//     remove(cardRef).then(() => {
//       alert("Product deleted successfully!");
//     }).catch((error) => {
//       alert("Error deleting product: " + error.message);
//     });
//   };

//   return (
//     <MainContainer>
//           <ImageSlider />
//           <ResponsiveTitle>Welcome to Umer Bazar</ResponsiveTitle>
//       <EmailInput
//         type="email"
//         placeholder="Enter your email"
//         value={email}
//         onChange={handleEmailChange}
//       />
//       <EnterButton onClick={handleEnterClick}>Enter</EnterButton>

//       {isAdmin && (
//         <>
//           <ImagePicker>
//             <h2>Admin Panel: Add Products</h2>
//             <ImageInput type="file" accept="image/*" onChange={handleImageChange} />
//             {imagePreviewUrl && <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />}
//             <TitleInput
//               type="text"
//               placeholder="Enter Product Title"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//             />
//             <DescriptionInput
//               placeholder="Enter Product Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//             />
//             <UrlInput
//               type="text"
//               placeholder="Enter Product URL"
//               value={url}
//               onChange={(e) => setUrl(e.target.value)}
//             />
//             <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
//           </ImagePicker>
//           <h2>Admin Panel: All Products</h2>
//         </>
//       )}

//       <ImagePreviewContainer>
//         {cards.map((card) => (
//           <Card key={card.id}>
//           <CardImage src={card.url} alt={card.title} />
//           <CardTitle>{card.title}</CardTitle>
          
//           {/* Description with Read More/Read Less functionality */}
//           <CardDescription>
//             {card.description.split(" ").length > 15 ? (
//               <>
//                 {card.isExpanded
//                   ? card.description
//                   : card.description.split(" ").slice(0, 15).join(" ") + "..."}
//                 <button
//                   onClick={() => {
//                     setCards((prevCards) =>
//                       prevCards.map((c) =>
//                         c.id === card.id ? { ...c, isExpanded: !card.isExpanded } : c
//                       )
//                     );
//                   }}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     color: "blue",
//                     textDecoration: "underline",
//                     cursor: "pointer",
//                     marginLeft: "10px",
//                   }}
//                 >
//                   {card.isExpanded ? "Read Less" : "Read More"}
//                 </button>
//               </>
//             ) : (
//               card.description
//             )}
//           </CardDescription>
        
//           {/* Admin specific actions */}
//           {isAdmin ? (
//             <>
//               <DeleteButton onClick={() => handleDelete(card.id)}>Delete</DeleteButton>
//               <CardButton onClick={() => window.location.href = card.buyUrl}>Buy Now</CardButton>
//             </>
//           ) : (
//             <CardButton onClick={() => window.location.href = card.buyUrl}>Buy Now</CardButton>
//           )}
//         </Card>
        
//         ))}
//       </ImagePreviewContainer>
//     </MainContainer>
//   );
// };

// export default Home;


import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { ref, set, push, onValue, remove, update } from "firebase/database";
import { FaEdit, FaTrash, FaShoppingCart, FaShareAlt,FaCopy } from "react-icons/fa";
import { FaUserTie, FaPhoneAlt, FaArrowRight, FaSearch } from "react-icons/fa";
import ImageSlider from '../Components/ImageSlider';

import {
  ref as storageRef,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
import { db, storage } from "../firebaseConfig";
import { useNavigate } from "react-router-dom"; // top me import

/* ---------------- BUTTONS ---------------- */

// Common Gradient Button

const GradientButton = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 100%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const GradientButton2 = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: #ffffffff;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 90%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const ButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;
const GradientButton1 = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 13px;
  margin-bottom: 13px;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 90%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const ResponsiveParagraph = styled.p`
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
  font-size: 18px;
  line-height: 1.6;
  color: #444;
  padding: 0 15px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;

    padding: 0 10px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.4;
    padding: 0 10px;
  }
`;
// Edit Button
const EditButtonStyled = styled(GradientButton)`
  background: linear-gradient(45deg, #f7971e, #ffd200);

  &:hover {
    background: linear-gradient(45deg, #ffd200, #f7971e);
  }
`;

// Delete Button
const DangerButton = styled(GradientButton)`
  background: linear-gradient(45deg, #ff416c, #ff4b2b);

  &:hover {
    background: linear-gradient(45deg, #ff4b2b, #ff416c);
  }
`;

// Button Row Wrapper
const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    gap: 12px;

    button {
      width: 100%;
      max-width: 320px;
    }
  }
`;

/* ---------------- LAYOUT + INPUTS ---------------- */

const MainContainer = styled.div`
  margin: 20;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 20px auto;
  max-width: 500px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 15px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    width: 90%;
    gap: 8px;
    padding: 12px;
  }

  @media (max-width: 480px) {
    width: 100%;
    border-radius: 6px;
    padding: 10px;
  }
`;

const StyledInput = styled.input`
  flex: 1;
  padding: 12px 15px;
  border: none;
  outline: none;
  font-size: 16px;
  border-radius: 6px;
  background: white;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    font-size: 15px;
    padding: 10px 12px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 10px;
  }
`;

const StyledButton = styled(GradientButton)`
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  color: #ffffffff;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  /* Tablet */
  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 0.95rem;
  }

  /* Mobile */
  @media (max-width: 480px) {
    width: 100%; /* mobile pe full width button */
    padding: 12px;
    font-size: 0.9rem;
    border-radius: 6px;
  }
`;

/* ---------------- IMAGE UPLOAD + FORM ---------------- */

const ImagePicker = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImagePreviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const ImagePreviewImg = styled.img`
  width: 150px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
`;

const TitleInput = styled.input`
  margin-top: 10px;
  padding: 10px;
  font-size: 18px;
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const DescriptionInput = styled.textarea`
  margin-top: 10px;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  height: 100px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const UrlInput = styled.input`
  margin-top: 10px;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

// const CountrySelect = styled.select`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;
const CountrySelect = styled.select`
  
  padding: 10px 12px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
  background: #fff;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:focus {
    border-color: #2575fc;
    box-shadow: 0 0 6px rgba(37, 117, 252, 0.5);
  }

  /* Tablet */
  @media (max-width: 768px) {
    font-size: 15px;
    padding: 10px;
    max-width: 100%;
  }

  /* Mobile */
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px;
    width: 100%;
    border-radius: 6px;
  }
`;

const SubmitButton = styled(GradientButton)`
  margin-top: 20px;
  border-radius: 8px;
`;

const CancelButton = styled(DangerButton)`
  margin-top: 10px;
  border-radius: 8px;
`;

/* ---------------- PRODUCT CARD ---------------- */

const Card = styled.div`
  border-radius: 16px;
  width: 100%;
  max-width: 350px;
  padding: 15px;

  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08); /* subtle border */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;
  // padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;

  &:hover {
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  /* Responsive design */
  @media (max-width: 1024px) {
    max-width: 300px;
    padding: 12px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 10px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 12px;
    border-radius: 12px;
  }
`;

const CardImage = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

const FlagImg = styled.img`
  width: 40px;
  margin-top: 10px;
  height: 25px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 35px;
    height: 22px;
  }
`;

const TitleText = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 10px;
  color: #0a2df3ff;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CardDescription = styled.p`
  font-size: 16px;
  color: #7c7979ff;
  padding: 0 10px;
  line-height: 1.6;
  text-align: center;
`;

const ResponsiveTitle = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  padding: 10px;
  margin: 20px 0;

  /* Default text (black) */
  background: black;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }

  /* Span with gradient text + light background */
  span {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 6px;

    /* Background box */
    background-color: rgba(240, 240, 240, 0.3);

    /* Gradient text */
    background-image: linear-gradient(90deg, #ffa600ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: #2575fc;
  font-weight: 600;
  cursor: pointer;
  margin-top: 6px;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;
// const GradientSection = styled.div`
//   width: 100%;
//   padding: 16rem 2rem; /* Desktop default */
//   background: linear-gradient(to bottom, #165a9eff, #000000ff);

//   color: white;
//   text-align: center;

//   @media (max-width: 1200px) {
//     padding: 12rem 2rem; /* Large laptops/tablets */
//   }

//   @media (max-width: 992px) {
//     padding: 10rem 1.5rem; /* Medium tablets */
//   }

//   @media (max-width: 768px) {
//     padding: 8rem 1rem; /* Small tablets / large phones */
//   }

//   @media (max-width: 480px) {
//     padding: 6rem 1rem; /* Mobile phones */
//   }
// `;

// const GradientTitle = styled.h1`
//   font-size: 2.5rem;
//   font-weight: bold;
//   margin-bottom: 1.5rem;
//   color: #ffa600ff;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }
// `;

// const GradientText = styled.p`
//   font-size: 1.2rem;
//   line-height: 1.8;
//   max-width: 700px;
//   margin: 0 auto;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;
/* ---------------- FLAGS ---------------- */

const countryFlags = {
  USA: "https://flagcdn.com/us.svg",
  UK: "https://flagcdn.com/gb.svg",
  Canada: "https://flagcdn.com/ca.svg",
  Germany: "https://flagcdn.com/de.svg",
  France: "https://flagcdn.com/fr.svg",
  Italy: "https://flagcdn.com/it.svg",
  UAE: "https://flagcdn.com/ae.svg",
  Spain: "https://flagcdn.com/es.svg",
  Australia: "https://flagcdn.com/au.svg",
  
};

/* ---------------- COMPONENT ---------------- */
const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ShareIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #0d0d0eff 0%, #022533ff 100%);
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.15) rotate(10deg);
    background: linear-gradient(135deg, #141616ff 0%, #4facfe 100%);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  }

  svg {
    color: white;
    font-size: 18px;
  }
`;

const CardTitle = styled.div`
  display: flex;
  flex-direction: column; /* 👈 vertical column layout */
  align-items: center; /* center horizontally */
  justify-content: center;
  text-align: center;
  gap: 8px; /* space between flag and title */
  margin-bottom: 10px;
`;
const Home = () => {
  // same logic as before (no change)
  // sirf UI styling update ki gayi hai
  // 👇👇👇
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [country, setCountry] = useState("");
  const [cards, setCards] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("All");
  const [isEditing, setIsEditing] = useState(false);
  const [editCardId, setEditCardId] = useState(null);
  const [expandedCards, setExpandedCards] = useState({});
  const navigate = useNavigate(); // for navigation
  const imagePickerRef = useRef(null);
  const handleEdit = (card) => {
    setIsEditing(true);
    setEditCardId(card.id);
    setTitle(card.title);
    setDescription(card.description);
    setUrl(card.buyUrl);
    setCountry(card.country || "");
    setImage(card.url);
    setImagePreviewUrl(card.url);

    // 🔹 Scroll ImagePicker pe
    if (imagePickerRef.current) {
      imagePickerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const toggleReadMore = (id) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    const cardsRef = ref(db, "cards");
    onValue(cardsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadedCards = Object.entries(data).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setCards(loadedCards.reverse());
      }
    });
  }, []);

  // const filteredCards = cards.filter((card) => {
  //   if (search.toLowerCase() === "all") return true;
  //   return card.country?.toLowerCase().includes(search.toLowerCase());
  // });
  const filteredCards = cards.filter((card) => {
    const matchesCountry =
      search.toLowerCase() === "all" ||
      card.country?.toLowerCase() === search.toLowerCase();
    const matchesSearch =
      card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      card.description.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCountry && matchesSearch;
  });

  const handleEnterClick = () => {
    if (email === "umerbazaribrahim@gmail.com") {
      setIsAdmin(true);
      alert("Welcome Admin!");
    } else {
      setIsAdmin(false);
      alert("You are viewing the Client Panel!");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const storageReference = storageRef(storage, `images/${file.name}`);
      const uploadTask = uploadBytesResumable(storageReference, file);

      uploadTask.on(
        "state_changed",
        null,
        (error) => console.error("Upload failed: ", error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setImage(downloadURL);
            setImagePreviewUrl(URL.createObjectURL(file));
          });
        }
      );
    }
  };
const handleCopyLink = (card) => {
    const productLink = `${window.location.origin}/product/${card.id}`;
    navigator.clipboard.writeText(productLink);
    alert("Product link copied: " + productLink);
  };
  const handleSubmit = () => {
    if (image && title && description && url && country) {
      if (isEditing && editCardId) {
        const cardRef = ref(db, "cards/" + editCardId);
        update(cardRef, {
          url: image,
          title,
          description,
          buyUrl: url,
          country,
          updatedAt: new Date().toISOString(),
        }).then(() => {
          alert("Product updated successfully!");
          resetForm();
        });
      } else {
        const newCardRef = push(ref(db, "cards"));
        const cardData = {
          url: image,
          title,
          description,
          buyUrl: url,
          country,
          createdAt: new Date().toISOString(),
        };
        set(newCardRef, cardData);
        resetForm();
      }
    } else {
      alert("Please fill in all fields before submitting.");
    }
  };

  const handleDelete = (id) => {
    const cardRef = ref(db, "cards/" + id);
    remove(cardRef).then(() => alert("Product deleted!"));
  };
  const handleShare = (card) => {
    const productLink = `${window.location.origin}/product/${card.id}`;

    if (navigator.share) {
      navigator.share({
        title: card.title,
        text: card.description,
        url: productLink,
      });
    } else {
      navigator.clipboard.writeText(productLink);
      alert("Link copied: " + productLink);
    }
  };

  const resetForm = () => {
    setImage(null);
    setImagePreviewUrl(null);
    setTitle("");
    setDescription("");
    setUrl("");
    setCountry("");
    setIsEditing(false);
    setEditCardId(null);
  };

  return (
    <>
      <ImageSlider />
      <MainContainer>
        

        <ResponsiveTitle>
          Welcome to ZoFinds
        </ResponsiveTitle>

        {/* Admin Email Input */}
        <InputRow>
          <StyledInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <StyledButton onClick={handleEnterClick}>
            <FaArrowRight size={18} />
            Enter
          </StyledButton>
          {isAdmin && (
            <DangerButton
              onClick={() => {
                setIsAdmin(false);
                setEmail("");
                alert("You have been logged out!");
              }}
            >
              Logout
            </DangerButton>
          )}
        </InputRow>
        <ResponsiveParagraph>
          <b>ZoFinds</b> is a participant in the{" "}
          <b>Amazon Associates Program</b>, an affiliate advertising program
          designed to provide a means for websites to earn advertising fees by
          promoting and linking to Amazon.com and its regional stores. We
          carefully select trending products, provide honest recommendations,
          and ensure that our visitors get updated deals with full transparency.
        </ResponsiveParagraph>

        {/* Admin Email Input */}

        {/* Customer Search */}

        {/* 👇 Search + Country Filter Section */}
        <InputRow>
          {/* Keyword Search */}
          <StyledInput
            type="text"
            placeholder="Search by title or description..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          {/* Country Dropdown */}
          <CountrySelect
            value={search} // selected country for filtering
            onChange={(e) => setSearch(e.target.value)}
          >
            <option value="All">🌐 All Countries</option>
            {Object.keys(countryFlags).map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </CountrySelect>

          {/* Filter Button */}
          <StyledButton onClick={() => setSearch(search || "All")}>
            <FaSearch size={16} />Search
          </StyledButton>
        </InputRow>

        {/* Admin Panel */}
        {isAdmin && (
          <>
            <ImagePicker ref={imagePickerRef}>
              <h2>
                {isEditing ? "Edit Product" : "Admin Panel: Add Products"}
              </h2>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imagePreviewUrl && (
                <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />
              )}
              <TitleInput
                type="text"
                placeholder="Enter Product Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <DescriptionInput
                placeholder="Enter Product Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <UrlInput
                type="text"
                placeholder="Enter Product URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
              <CountrySelect
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option value="">Select Country</option>
                {Object.keys(countryFlags).map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </CountrySelect>

              <SubmitButton onClick={handleSubmit}>
                {isEditing ? "Update Product" : "Submit"}
              </SubmitButton>
              {isEditing && (
                <CancelButton onClick={resetForm}>Cancel</CancelButton>
              )}
            </ImagePicker>
            <h2>Admin Panel: All Products</h2>
          </>
        )}

        {/* Products */}
        <ImagePreviewContainer>
          {filteredCards.length > 0 ? (
            filteredCards.map((card) => {
              const words = card.description.split(" ");
              const isExpanded = expandedCards[card.id];
              const shortText = words.slice(0, 30).join(" ");
              const shouldTruncate = words.length > 30;

              return (
                <Card key={card.id}>
                  <CardImageWrapper>
                    <CardImage src={card.url} alt={card.title} />

                    {/* Share Icon */}
                    <ShareIcon  style={{ background: "#1151c0" }} onClick={() => handleShare(card)}>
                      <FaShareAlt />
                    </ShareIcon>

                    {/* Copy Icon */}
                    <ShareIcon
                      style={{ top:"60px", background: "#1151c0" }}
                      onClick={() => handleCopyLink(card)}
                    >
                      <FaCopy />
                    </ShareIcon>
                  </CardImageWrapper>


                  <CardTitle>
                    <TitleText>{card.title}</TitleText>
                    {card.country && countryFlags[card.country] && (
                      <FlagImg
                        src={countryFlags[card.country]}
                        alt={card.country}
                      />
                    )}
                  </CardTitle>

                  <CardDescription>
                    {isExpanded ? card.description : shortText}
                    {shouldTruncate && (
                      <>
                        {!isExpanded && "..."}
                        <br />
                        <ReadMoreButton onClick={() => toggleReadMore(card.id)}>
                          {isExpanded ? "Read Less" : "Read More"}
                        </ReadMoreButton>
                      </>
                    )}
                  </CardDescription>

                  {isAdmin ? (
                    <ButtonRow>
                      <EditButtonStyled onClick={() => handleEdit(card)}>
                        <FaEdit /> Edit
                      </EditButtonStyled>
                      <DangerButton onClick={() => handleDelete(card.id)}>
                        <FaTrash /> Delete
                      </DangerButton>
                      <GradientButton
                        onClick={() => (window.location.href = card.buyUrl)}
                      >
                        <FaShoppingCart /> Buy Now
                      </GradientButton>
                    </ButtonRow>
                  ) : (
                    <GradientButton1
                      onClick={() => (window.location.href = card.buyUrl)}
                    >
                      <FaShoppingCart /> Buy Now
                    </GradientButton1>
                  )}
                </Card>
              );
            })
          ) : (
            <p>No products found for "{search}"</p>
          )}
        </ImagePreviewContainer>
      </MainContainer>
    </>
  );
};

export default Home;
